import { render, staticRenderFns } from "./CaseFreeTextSearchList.vue?vue&type=template&id=5443f5a8&scoped=true&"
import script from "./CaseFreeTextSearchList.vue?vue&type=script&lang=js&"
export * from "./CaseFreeTextSearchList.vue?vue&type=script&lang=js&"
import style0 from "./CaseFreeTextSearchList.vue?vue&type=style&index=0&id=5443f5a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5443f5a8",
  null
  
)

export default component.exports